import { useState } from 'react'
import { useEffect } from 'react'
import './styles/vendas.css'

// Icones SVG
const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
)

const IconLock = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
)

const IconCheck = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

// Bullet point verde pequeno
// const IconIdentificacao = () => (
//   <svg width="6" height="6" viewBox="0 0 6 6" className="icon-identificacao">
//     <circle cx="3" cy="3" r="3" fill="#22c55e" />
//   </svg>
// )

// Ícone de traço/menos — usado no comparativo "Continuar Como Está"
const IconMinus = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

const IconChevron = ({ open }: { open: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
)

// Componente FAQ Expansível
const FAQItem = ({ pergunta, resposta }: { pergunta: string; resposta: string }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className={`faq-item ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
      <div className="faq-header">
        <h3>{pergunta}</h3>
        <IconChevron open={open} />
      </div>
      <div className="faq-content" style={{ maxHeight: open ? '200px' : '0', overflow: 'hidden', transition: 'maxHeight 0.3s ease' }}>
        <p>{resposta}</p>
      </div>
    </div>
  )
}

const VendasPage = () => {
  useEffect(() => {
    const viewport = document.querySelector('meta[name=viewport]')
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
    }
  }, [])

  const scrollToProblema = () => {
    document.getElementById('problema')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="vendas-page">
      {/* HERO */}
      <section className="hero">
        <div className="hero-badge">GUIA DIGITAL COMPLETO E PRÁTICO</div>

        <h1 className="hero-title">
          Transforme o Caos do TDAH em Conexão —
          <span className="highlight"> Sem Brigas, Sem Culpa e Sem Remédios Mágicos</span>
        </h1>

        <p className="hero-subtitle">
          Seu filho não tem "falha de caráter" nem preguiça. O cérebro dele apenas funciona em uma marcha diferente.
          Descubra como traduzir esse mundo, reconquistar a paz em casa e se tornar a maior aliada (e não a vilã) do desenvolvimento dele.
        </p>

        <div className="hero-imagem-container">
          <img src="/capa-ebook.jpg" alt="Entendendo o TDAH - Um guia prático e acolhedor" className="hero-imagem" />
        </div>

        <button className="cta-button" onClick={scrollToProblema}>
          QUERO ENTENDER MEU FILHO
          <IconArrow />
        </button>
      </section>

      {/* PROBLEMA */}
      <section id="problema" className="section">
        <div className="section-tag">A Realidade Exaustiva</div>
        <h2>A jornada até aqui tem sido cansativa e solitária?</h2>

        <div className="problemas-lista">
          <div className="problema-item">
            <span style={{ fontSize: '1.5rem' }}>😫</span>
            <div>
              <strong style={{ display: 'block', color: 'var(--cor-primaria)' }}>"Por que tudo tem que ser uma guerra?"</strong>
              <span style={{ fontSize: '0.9rem' }}>As manhãs são um caos, a lição de casa vira um campo de batalha e você vai dormir esgotada, carregando a culpa de ter gritado de novo.</span>
            </div>
          </div>
          <div className="problema-item">
            <span style={{ fontSize: '1.5rem' }}>😤</span>
            <div>
              <strong style={{ display: 'block', color: 'var(--cor-primaria)' }}>"Ninguém entende o que passamos."</strong>
              <span style={{ fontSize: '0.9rem' }}>A escola só manda bilhetes de reclamação. Familiares e amigos julgam pelas costas, sugerindo que tudo é apenas "falta de limites e chinelada".</span>
            </div>
          </div>
          <div className="problema-item">
            <span style={{ fontSize: '1.5rem' }}>😰</span>
            <div>
              <strong style={{ display: 'block', color: 'var(--cor-primaria)' }}>"Já gastei uma fortuna e nada muda."</strong>
              <span style={{ fontSize: '0.9rem' }}>Terapias caras e consultas com médicos que apenas passam receitas, enquanto a rotina dentro da sua casa continua exatamente igual.</span>
            </div>
          </div>
          <div className="problema-item">
            <span style={{ fontSize: '1.5rem' }}>🤯</span>
            <div>
              <strong style={{ display: 'block', color: 'var(--cor-primaria)' }}>"Tenho medo do futuro dele."</strong>
              <span style={{ fontSize: '0.9rem' }}>Ao ver a baixa autoestima do seu filho crescer, o medo secreto de que ele seja excluído, sofra bullying ou "não dê em nada" te assombra.</span>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION / STORY */}
      <section className="section section-cinza">
        <div className="section-tag">O Momento da Virada</div>

        <h2>"Eu achava que terceirizar o problema resolveria... Até perceber o que faltava."</h2>

        <p>
          Quando recebi o diagnóstico de TDAH do meu filho, acreditei que a solução era levá-lo aos profissionais certos
          e esperar o comportamento mudar. <strong>Mas a mudança não acontecia.</strong>
        </p>

        <div className="story-lista">
          <div className="story-item">As consultas tratavam sintomas, mas não a causa diária.</div>
          <div className="story-item">Os psicólogos faziam um ótimo trabalho na clínica, mas não estavam na minha casa às 7h da manhã.</div>
          <div className="story-item">A escola terceirizava a culpa para a família.</div>
        </div>

        <div className="destaque">
          <h3>A Verdadeira Solução</h3>
          <p>
            Foi então que entendi: <strong>Eu não precisava ser terapeuta do meu filho, precisava ser a tradutora dele.</strong>
          </p>
          <p>
            Quando parei de me frustrar com as explosões emocionais e entendi a <em>mecânica exata</em> por trás da falta de foco
            e da hiperatividade, comecei a prever e desarmar as crises antes mesmo delas começarem. O TDAH perdeu a força sobre nós.
          </p>
        </div>
      </section>

      {/* CONTEUDO */}
      <section className="section">
        <div className="section-tag">Benefícios Reais (Não Teoria)</div>

        <h2>Um mapa prático, livre de jargões técnicos complexos e direto ao ponto.</h2>

        {[
          { num: "01", titulo: "Desarmando o Caos Matinal", desc: "Aprenda por que o cérebro com TDAH trava nas transições de rotina e o que fazer para destravar.", ganho: "Sair de casa sem gritos ou atrasos." },
          { num: "02", titulo: "O Botão Oculto da Atenção", desc: "A diferença científica entre 'não conseguir focar' e 'não estar estimulado'.", ganho: "Conseguir que ele faça a lição de casa em paz." },
          { num: "03", titulo: "Cérebro Superaquecido", desc: "Entenda a neurobiologia das explosões emocionais e da frustração repentina.", ganho: "Capacidade de prever e acalmar crises emocionais." },
          { num: "04", titulo: "A Proporção Mágica de Punição vs Validação", desc: "A técnica comprovada para reconstruir a auto-estima esmagada do seu filho.", ganho: "Restaurar a conexão e quebrar o ciclo de 'criança má'." },
          { num: "05", titulo: "Sobrevivendo ao Sistema Escolar", desc: "As palavras exatas para usar em reuniões com professores e seus direitos na Lei 14.254/2021.", ganho: "Ter a escola como aliada, não como inimiga." },
          { num: "06", titulo: "A Verdade Sobre Remédios", desc: "Análise fria e baseada em evidências sobre o uso e efeitos colaterais de medicações e suplementos naturais.", ganho: "Paz de espírito para tomar decisões com seus médicos." },
          { num: "07", titulo: "Dieta e TDAH", desc: "A influência real do ômega-3, zinco, açúcar excessivo e como organizar a lancheira.", ganho: "Melhora natural de foco através da nutrição básica." }
        ].map((mod) => (
          <div className="modulo" key={mod.num}>
            <div className="modulo-header">
              <span className="modulo-num">{mod.num}</span>
              <span className="modulo-titulo">{mod.titulo}</span>
            </div>
            <p className="modulo-desc">{mod.desc}</p>
            <div className="modulo-ganho"><strong>Transformação esperada:</strong> {mod.ganho}</div>
          </div>
        ))}
      </section>

      {/* DEPOIMENTOS */}
      <section className="section section-cinza">
        <div className="section-tag">Provas Incontestáveis</div>

        <h2>Resultados de Paz Real em Famílias Reais</h2>

        <div className="depoimento">
          <p className="depoimento-texto">
            "As manhãs eram um caos absoluto. Gritos, choro pra vestir o uniforme e atrasos. Apliquei um único ajuste de transição cognitiva do guia. Em 3 dias, ele passou a calçar o tênis sozinho. Parecia mágica, mas era só comunicação correta."
          </p>
          <div className="depoimento-autor">
            <strong>Patrícia D.</strong> — <span>Mãe de Sofia (11 anos), Resultado Rápido</span>
          </div>
        </div>

        <div className="depoimento">
          <p className="depoimento-texto">
            "Eu já gastava quase mil reais por mês com terapeutas, e as ligações da escola não paravam. Quando entendi a diferença entre indisciplina e imaturidade executiva ensinada neste manual, tirei um fardo enorme de mim."
          </p>
          <div className="depoimento-autor">
            <strong>Juliana R.</strong> — <span>Mãe de Enzo (6 anos), A Cética Convertida</span>
          </div>
        </div>

        <div className="depoimento">
          <p className="depoimento-texto">
            "Ver meu filho ganhar estrelinhas na escola pela primeira vez, e o sorriso de orgulho no rosto dele, pagou este guia mil vezes."
          </p>
          <div className="depoimento-autor">
            <strong>André S.</strong> — <span>Pai de Gabriel (8 anos), Grande Vitória</span>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="section-tag">Dúvidas Frequentes</div>

        <h2>Restou alguma pergunta?</h2>

        <FAQItem
          pergunta="Já tentei métodos de outros livros antes. Por que esse funcionaria?"
          resposta="A maioria dos materiais são técnicos demais ou escritos por pessoas que não vivem o TDAH na prática. Este não é um livro maçante, é um manual tático imediato focado em ações comportamentais do dia a dia."
        />

        <FAQItem
          pergunta="Este guia substitui as consultas?"
          resposta="Absolutamente não. Ele otimiza. Ao invés de você chegar no médico relatando 'meu filho está agitado', você vai começar a enxergar padrões, entender os gatilhos e exigir terapias mais precisas."
        />

        <FAQItem
          pergunta="Meu filho não toma medicação. O livro serve?"
          resposta="Sim, o eixo principal do guia é manejo ambiental (rotina, comunicação e validação), que é universal e imperativo independentemente do uso de remédios."
        />

        <FAQItem
          pergunta="Acho que eu (pai/mãe) também tenho TDAH. O guia me ajuda?"
          resposta="Definitivamente. Ao desconstruir a forma como a dopamina e as funções executivas trabalham no cérebro infantil, muitos pais compreendem a si mesmos durante esse processo de leitura."
        />

        <FAQItem
          pergunta="Como recebo o acesso?"
          resposta="O acesso é totalmente digital e enviado ao seu e-mail no mesmo momento da aprovação do pagamento. Você lê pelo celular, tablet ou manda imprimir se quiser."
        />
      </section>

      {/* COMPARATIVO */}
      <section className="section section-cinza">
        <div className="section-tag">Análise Fria</div>

        <h2>O Custo de Não Tomar Uma Atitude Hoje</h2>

        <div className="comparativo">
          <div className="comparativo-nao">
            <div className="comparativo-header-nao">Custo Invisível</div>
            <h3>Se você fechar esta página agora:</h3>
            <div className="comparativo-lista">
              <div className="comparativo-item-nao"><IconMinus /> <span>As manhãs continuarão sendo desgastantes e caóticas</span></div>
              <div className="comparativo-item-nao"><IconMinus /> <span>A autoestima dele despencará ao entrar na adolescência</span></div>
              <div className="comparativo-item-nao"><IconMinus /> <span>A culpa silenciosa te consumirá toda noite ao apagar a luz</span></div>
            </div>
          </div>

          <div className="comparativo-sim">
            <div className="comparativo-header-sim">Futuro Promissor</div>
            <h3>Com as chaves certas em mãos:</h3>

            <div className="comparativo-lista">
              <div className="comparativo-item-sim"><IconCheck /> <span>Você e ele jogando no mesmo time, sem inimigos em casa</span></div>
              <div className="comparativo-item-sim"><IconCheck /> <span>Escola apontará as melhoras e você terá orgulho nas reuniões</span></div>
              <div className="comparativo-item-sim"><IconCheck /> <span>Paz mental inabalável e segurança de que ele está protegido</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* OFERTA */}
      <section id="oferta" className="oferta">
        <div className="oferta-box">
          <div className="oferta-tag">Preço de Lançamento</div>

          <h2 className="oferta-titulo">Entendendo o TDAH na Prática</h2>

          <p className="oferta-subtitle">
            Por menos do que o valor de uma pizza, descubra os atalhos psicológicos para acabar com os gritos em casa e criar um filho confiante e capaz.
          </p>

          <div className="hero-imagem-container oferta-imagem">
            <img src="/capa-ebook.jpg" alt="Entendendo o TDAH - Um guia prático e acolhedor" className="hero-imagem" />
          </div>

          <div className="preco">
            <div className="preco-antigo">De R$ 97,00</div>
            <div className="preco-novo">R$ 47,00</div>
            <div className="preco-parcela">ou até 12x de R$ 5,47 no cartão</div>
          </div>

          <a
            href="https://pay.cakto.com.br/eee94gz_770120"
            className="cta-button cta-large"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            PRECISO DESSE MANUAL AGORA
            <IconArrow />
          </a>

          <div style={{ marginTop: '0.75rem', fontSize: '0.85rem', color: 'rgba(255,255,255,0.9)' }}>
            ✓ Acesso imediato no seu e-mail
          </div>

          <div className="garantia">
            <IconLock />
            <div className="garantia-texto">
              <strong>Garantia Incondicional de 7 Dias</strong>
              <p>Baixe, leia e aplique por 7 dias. Se você achar que a dinâmica da sua casa não melhorou nem um pouco, devolvemos 100% do valor. O risco é todo nosso.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <p>2026 — Todos os direitos reservados.</p>
        <p>Este site não garante resultados específicos. Resultados podem variar. Material para fins educacionais.</p>
      </footer>
    </div>
  )
}

export default VendasPage
